import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingComponentsService {
  loadingComponent$: Subject<boolean> = new Subject();

  start() {
    this.loadingComponent$.next(true);
  }

  stop() {
    this.loadingComponent$.next(false);
  }
}
